import React from 'react';
import MaterialTableHead from '@mui/material/TableHead';
import type {TableHeadProps as MaterialTableHeadProps} from '@mui/material/TableHead';
import {styled} from '@mui/material/styles';

export type TableHeadProps = MaterialTableHeadProps;

const StyledTableHead = styled(MaterialTableHead)(({theme}) => ({
    borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
    '& .MuiTableCell-stickyHeader': {
        backgroundColor: theme.tokens.FuelColorWhite,
        borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
        borderCollapse: 'collapse'
    },
    '& .MuiTableCell-sizeSmall': {
        padding: `0.375rem ${theme.tokens.FuelSpacing4}`
    }
}));

export const TableHead = React.forwardRef<any, TableHeadProps>(({
    children, ...props
},
ref) => (
    <StyledTableHead
        ref={ref}
        {...props}
    >
        {children}
    </StyledTableHead>
));

TableHead.displayName = 'TableHead';
